import { useMemo } from "react";
import { SelectedThemeAndTemplateData } from "../components/shop/popups/SelectTemplatePopup/TemplateTabs";
import { get } from "lodash";
import { TEMPLATE_OPTIONS } from "../components/shop/helpers";
import { ITemplateData } from "../interfaces/PublicViewTemplateData";

export const useThemeData = (
  themeName: string,
  selectedTheme?: SelectedThemeAndTemplateData,
  selectedTemplate?: SelectedThemeAndTemplateData
): ITemplateData => {
  return useMemo(() => {
    return {
      ...(TEMPLATE_OPTIONS[themeName] as ITemplateData || {}),
      ...Object.values(selectedTemplate?.properties || {}).reduce(
        (acc, v) => ({
          ...acc,
          [v.public_view_template_property_name]:
            v.public_view_template_property_value,
        }),
        {}
      ),
      ...Object.values(get(selectedTheme, ["template_data"]) || {}).reduce(
        (acc, v) => ({ ...acc, [v.name]: v.value }),
        {}
      ),
    };
  }, [themeName, selectedTheme, selectedTemplate]);
};
